/**
 * Stops media in inactive video-tabs: HTML5 pause + YouTube iframe unload (about:blank).
 * Restores YouTube src on the active tab. Does not use postMessage (avoids origin / API issues).
 */
(function () {
  const BLANK = 'about:blank';

  const stashYoutubeSrc = (iframe) => {
    const src = iframe.getAttribute('src') || iframe.src;
    if (!src || src === BLANK || !src.includes('youtube')) {
      return;
    }
    if (!iframe.dataset.byteYoutubeSrc) {
      iframe.dataset.byteYoutubeSrc = src;
    }
  };

  const unloadYoutubeIframes = (root) => {
    for (const iframe of root.querySelectorAll(
      'iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"], iframe[data-byte-youtube-src]'
    )) {
      stashYoutubeSrc(iframe);
      if (iframe.src && iframe.src !== BLANK) {
        iframe.src = BLANK;
      }
    }
  };

  const restoreYoutubeIframes = (root) => {
    for (const iframe of root.querySelectorAll('iframe[data-byte-youtube-src]')) {
      const orig = iframe.dataset.byteYoutubeSrc;
      if (!orig) {
        continue;
      }
      const current = iframe.getAttribute('src') || iframe.src || '';
      if (current === BLANK || current === '' || !current.includes('youtube')) {
        iframe.src = orig;
      }
    }
  };

  const pausePanel = (panel) => {
    if (!panel) {
      return;
    }

    for (const video of panel.querySelectorAll('video')) {
      try {
        video.pause();
      } catch {
        /* ignore */
      }
    }

    for (const media of panel.querySelectorAll('video-media')) {
      try {
        if (typeof media.pause === 'function') {
          media.pause();
        }
      } catch {
        /* ignore */
      }
    }

    unloadYoutubeIframes(panel);
  };

  const syncPanels = (tabs) => {
    if (!tabs || typeof tabs.querySelectorAll !== 'function') {
      return;
    }

    const selected = Number.parseInt(tabs.getAttribute('selected-index') || '0', 10) || 0;
    const panels = tabs.querySelectorAll('.video-tabs__panel');

    panels.forEach((panel, index) => {
      if (index !== selected) {
        pausePanel(panel);
      } else {
        restoreYoutubeIframes(panel);
      }
    });
  };

  const bindTabs = (tabs) => {
    if (!tabs || tabs.dataset.byteVideoTabsPauseBound === '1') {
      return;
    }

    tabs.dataset.byteVideoTabsPauseBound = '1';

    const run = () => {
      syncPanels(tabs);
    };

    const mo = new MutationObserver(run);
    mo.observe(tabs, { attributes: true, attributeFilter: ['selected-index'] });

    run();
  };

  const init = (root = document) => {
    for (const tabs of root.querySelectorAll('x-tabs.video-tabs')) {
      bindTabs(tabs);
    }
  };

  if (!document.documentElement.dataset.byteVideoTabsPauseDoc) {
    document.documentElement.dataset.byteVideoTabsPauseDoc = '1';

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.video-tabs__title');
        if (!button) {
          return;
        }

        const tabs = button.closest('byte-video-tabs')?.querySelector('x-tabs.video-tabs');
        if (!tabs) {
          return;
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            syncPanels(tabs);
          });
        });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', () => {
    init(document);
  });
})();
